import React from 'react';
import { Box } from '@material-ui/core';

interface Props {
    children?: React.ReactNode;
}

function PageToolbar(props: Props) {
    return (
        <Box p={2} display="flex" alignItems="center" justifyContent="right">
            {props.children}
        </Box>
    );
}

export default PageToolbar;